export default (axios, baseURL) => async (excursionId, payload, queryParams) => {
  const axiosConfig = {
    method: 'PATCH',
    baseURL,
    url: `/v2/excursions/${encodeURIComponent(excursionId)}/students`,
    params: queryParams,
    data: { ...payload }
  };
  try {
    const axiosResponse = await axios(axiosConfig);

    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  } catch (error) {
    if (error.response) {
      return {
        error: {
          statusCode: error.response.status,
          message: error.response.data && error.response.data.message
        }
      };
    }
    throw error;
  }
};
